"use client"
import Image from "next/image"
import { type FC, useState } from "react"
import type { ImagePropsWithRequiredFallback } from "./types"

export const ImageWithFallback: FC<ImagePropsWithRequiredFallback> = ({
  src,
  fallbackSrc,
  ...props
}) => {
  const [error, setError] = useState(false)

  return (
    <Image
      src={error ? fallbackSrc : src}
      unoptimized={!error}
      onError={() => setError(true)}
      {...props}
    />
  )
}
